import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useModalClose from '../../hooks/useModalClose';
import { NoDescriptionIcon } from '../../assets/icons';
import { formatDateWithHourAndMinute } from '../../helpers/stringHelpers';

const WasteDetailModal = ({ isOpen, onClose, wasteData }) => {
  useModalClose(isOpen, onClose);
  const [selectedBagQr, setSelectedBagQr] = useState(null);

  // Get received bags sorted by dateReceived (newest first)
  const receivedBags = wasteData?.records
    ?.filter(r => r.dateReceived)
    .sort((a, b) => new Date(b.dateReceived) - new Date(a.dateReceived)) || [];

  // Only set initial selected bag when modal opens
  useEffect(() => {
    if (isOpen && receivedBags.length > 0) {
      setSelectedBagQr(receivedBags[0].qr);
    } else {
      setSelectedBagQr(null);
    }
  }, [isOpen]); // Only depend on isOpen

  if (!isOpen || !wasteData) return null;

  // Get given but not received bags
  const givenBags = wasteData.records.filter(r => r.dateGiven && !r.dateReceived);

  const handleReceivedBagClick = (record) => {
    setSelectedBagQr(record.qr);
  };

  const selectedBag = receivedBags.find(bag => bag.qr === selectedBagQr);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content waste-detail-modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Haneye Dair Detaylar</h3>
        </div>
        
        <div className="modal-body">
          <div className="detail-section">
            <h4>Adres :</h4>
            <p>{wasteData.address}</p>
          </div>

          <div className="detail-section given-section">
            <h4>Verilen Poşetler ve Tarihi</h4>
            <div className="records-list">
              {givenBags.length > 0 ? (
                givenBags.map((record, index) => (
                  <div key={index} className="record-item given">
                    <span className="qr-code">{record.qr}</span>
                    <span className="date">{formatDateWithHourAndMinute(record.dateGiven)}</span>
                  </div>
                ))
              ) : (
                <p className="no-records">Verilmiş poşet bulunmamaktadır</p>
              )}
            </div>
          </div>

          <div className="detail-section">
            <h4>Alınan Atık ve Tarihi</h4>
            <div className="records-list">
              {receivedBags.length > 0 ? (
                receivedBags.map((record, index) => (
                  <div 
                    key={index} 
                    className={`record-item received ${record.qr === selectedBagQr ? 'selected' : ''}`}
                    onClick={() => handleReceivedBagClick(record)}
                  >
                    <span className="qr-code">{record.qr}</span>
                    <span className="date">{formatDateWithHourAndMinute(record.dateReceived)}</span>
                  </div>
                ))
              ) : (
                <p className="no-records">Alınmış atık bulunmamaktadır</p>
              )}
            </div>
          </div>

          {receivedBags.length > 0 && selectedBag && (
            <div className="detail-section">
              <h4>Açıklamalar: </h4>
              {selectedBag.description ? (
                <p className="description">
                  {selectedBag.description}
                </p>
              ) : (
                <div className="no-description">
                  <NoDescriptionIcon width={88} height={88} />
                  <p><span>{selectedBag.qr} poşeti</span> ile ilgili<br/>açıklama bulunmamaktadır</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

WasteDetailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  wasteData: PropTypes.object
};

export default WasteDetailModal; 